import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./hooks/useAuth";
import { CreditsProvider } from "./hooks/useCredits";
import { BrandProvider } from "./hooks/useBrand";
import { ConfirmProvider } from "./hooks/useConfirm";
import { FacebookConnectionProvider } from "./hooks/useFacebookConnection";
import { InviteLayer } from "./components/feature/InviteGate";
import { MaintenanceLayer } from "./components/feature/MaintenanceGate";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      {/* Maintenance kill switch — outermost. When the backend reports
          maintenance (GET /api/status), nothing else mounts; the whole app
          is replaced by a full-screen "back soon" page. Fails open. */}
      <MaintenanceLayer>
      <AuthProvider>
        {/* Pre-launch invite-only gate (no-op unless VITE_INVITE_ONLY is on).
            Sits inside AuthProvider so it can bypass for live sessions; wraps
            everything else so an uninvited visitor sees only the code screen. */}
        <InviteLayer>
          <CreditsProvider>
            <BrandProvider>
              <FacebookConnectionProvider>
                <ConfirmProvider>
                  <BrowserRouter basename={__BASE_PATH__}>
                    <AppRoutes />
                  </BrowserRouter>
                </ConfirmProvider>
              </FacebookConnectionProvider>
            </BrandProvider>
          </CreditsProvider>
        </InviteLayer>
      </AuthProvider>
      </MaintenanceLayer>
    </I18nextProvider>
  );
}

export default App;
